/**
 * The tenant @font-face rules, rebuilt for the hosted Dojo card iframe.
 *
 * `config/theme.ts` injects the same two faces into the app through
 * MuiCssBaseline; the iframe is a separate document, so it needs its own copy.
 *
 * Dojo will only take stylesheet *URLs* (`fontCss`), which it fetches with
 * XMLHttpRequest, filters down to the @font-face rules, and posts into the
 * iframe — and it blanks any `rawCss` handed to it directly. Hence a blob URL
 * rather than inline CSS: it's same-origin, so the fetch needs no CORS, and
 * XHR reports 200 for it (Dojo drops anything else on the floor).
 */
const tenantFonts = [
    { family: 'TenantFont', asset: 'customfont' },
    { family: 'SecondaryFont', asset: 'secondary_custom_font' }
];

/**
 * Dojo's parser matches `@font-face` rules with `/@font-face[ ]?{[^}]*}/`, so
 * each rule needs to stay on one brace level with at most one space before it.
 */
const fontFaceRule = (family: string, url: string) =>
    `@font-face {font-family: '${family}'; src: url(${url});}`;

/**
 * Returns an object URL for a stylesheet holding the merchant's font faces.
 * The caller owns it and should revoke it once the form is gone.
 */
export const createTenantFontCssUrl = (merchantId: string) => {
    const assetFolder = `${process.env.MEDIA_URL}/tenants/${merchantId}/app_assets`;
    const css = tenantFonts
        .map(({ family, asset }) => fontFaceRule(family, `${assetFolder}/${asset}`))
        .join('\n');
    return URL.createObjectURL(new Blob([css], { type: 'text/css' }));
};
